var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-register"},[_c('div',{staticClass:"c-register__body"},[_c('app-intro',[_c('h1',[_vm._v("Registreren")])]),_c('register-form',{attrs:{"theme":"light"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }